import React from "react";

export const JackPot = () => {
    return <div className='px-3 md:px-4 xl:px-9 py-3 md:py-6 bg-bg-light flex flex-col-reverse md:flex-row justify-between gap-3 mt-[60px] h-full md:h-[calc(100vh-60px)] overflow-auto'>

    </div>
}